// extracted by mini-css-extract-plugin
module.exports =  {"container":"da51a739f7--container--AldTf","disclaimer":"da51a739f7--disclaimer--iAf9f","video":"da51a739f7--video--K1Fl2"};